<template>
  <section class="container container__top">
    <h1 :class="['container__header', { 'container__header--margin': !useActionSlot }]">
      <slot name="header"></slot>
    </h1>

    <slot name="top-actions"></slot>

    <slot name="main"></slot>
  </section>
</template>

<script>
export default {
  computed: {
    useActionSlot() {
      return this.$slots['top-actions'] !== undefined
    }
  }
}
</script>

<style lang="scss">
.container__header {
  margin-top: 0;
  margin-bottom: measure(half);
}

.container__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: measure(half);

  @include media(large) {
    flex-direction: row;
    align-items: flex-start;
  }
}

.container__actions-elements {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @include media(large) {
    width: auto;
  }
}

.container__actions-text {
  max-width: 37.5rem;
  width: 100%;
  margin: 0 auto measure(half) 0;

  @include media(large) {
    max-width: 37.5rem;
    margin-bottom: 0;
  }
}

.container__actions-dropdown {
  width: 100%;

  @include media(small) {
    min-width: 17rem;
    width: auto;
    margin-left: measure(full);
  }
}

.container__actions-dropdown .dropdown__container {
  min-width: initial;
  width: 100%;
}

.container__header-bar {
  padding-top: measure(quarter);
  padding-bottom: measure(quarter);
  background-color: color(background-blue);
}

.container__header-element {
  @include container;
  @include h2-semi-bold;
  display: block;
  margin-top: 0;
  margin-bottom: 0;
  color: color(text-inverted);
}

.container__top {
  padding-top: measure(half);
  padding-bottom: 0;

  @include media(medium) {
    padding-top: measure(double);
    padding-bottom: measure(double);
  }
}
</style>
